/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
export const isAuthenticated = (state) => {
    return Boolean(state.token && state.user && state.authRole);
  };
  
  export const isSuperAdmin = (state) => state.authRole === "superAdmin";
  export const isTenant = (state) => state.authRole === "tenant";
  
  export const hasPermission = (state, key) => {
    if (state.isTenantOwner && isTenant(state)) return true;
    return Boolean(state.permissions[key]);
  };
  